import Immutable from 'immutable';
import {ReduceStore} from 'flux/utils';

import Dispatcher from 'service/Dispatcher';

import {RedeemAction, UserAction} from 'AppAction';

class RedeemStore extends ReduceStore {

	constructor() {
		super(Dispatcher);
	}

	getInitialState() {
		return Immutable.List();
	}

	getReedemHistory() {
		return this.getState();
	}
	
	reduce(state, action) { 
		switch (action.type) {
			case RedeemAction.LOAD_REDEEM_HISTORY:
				const redeemHistory = action.redeemHistory;
				return Immutable.List(redeemHistory);

			case RedeemAction.REDEEMED:
				return state.clear();

			case UserAction.LOGOUT:
				return state.clear();

			default:
				break;
		}
		

		return state;
	}
}

export default new RedeemStore();




// WEBPACK FOOTER //
// ./src/stores/RedeemStore.js